import React from 'react';
import { Card, CardHeader } from '@material-ui/core';
import { toast } from 'react-toastify';
import { LayoutPageGrid } from '../../../ui/LayoutGrid';
import { Loading } from '../../../ui/Loading';
import { usePremiumInfoQuery } from '../../../schema';
import { PremiumInfoCard, MechanicsCard } from './components';

export const PremiumAccessPage = () => {
  const { data, loading, error } = usePremiumInfoQuery();

  if (loading) {
    return <Loading />;
  }

  if (error) {
    toast.error('Ошибка загрузки информации о Premium-доступе');
    return null;
  }

  return (
    <LayoutPageGrid title="Premium-доступ">
      <Card>
        <CardHeader title="Информация о блоке" />
        <PremiumInfoCard data={data} />
      </Card>
      <Card>
        <CardHeader title="Правила оформления Premium-доступа" />
        <MechanicsCard data={data} />
      </Card>
    </LayoutPageGrid>
  );
};
